import React, { FC } from "react";

import { useTheme } from "@mui/material";
import {
  DataGridProProps,
  GetColumnForNewFilterArgs,
  DataGridPro as MuiDataGridPro,
} from "@mui/x-data-grid-pro";

import { TABLE_ROW_COUNT_OPTIONS } from "../constants/table";
import { useSettings } from "../hooks/use-settings";

const DataGridPro: FC<React.PropsWithChildren<DataGridProProps>> = (props) => {
  const theme = useTheme();
  const settings = useSettings();
  const getColumnForNewFilter = ({ columns }: GetColumnForNewFilterArgs) => {
    const firstVisibleColumn = columns.find(
      (col) =>
        col.filterable && props.columnVisibilityModel?.[col?.field] !== false,
    )?.field;
    return (
      firstVisibleColumn ?? columns.find((col) => col.filterable)?.field ?? null
    );
  };
  return (
    <MuiDataGridPro
      checkboxSelection
      disableColumnPinning
      disableRowSelectionOnClick
      pageSizeOptions={TABLE_ROW_COUNT_OPTIONS}
      pagination
      initialState={{
        ...props.initialState,
        pagination: { paginationModel: { pageSize: settings.rowCount || 10 } },
      }}
      sx={{
        "& .MuiDataGrid-columnHeader": {
          backgroundColor: theme.palette.background.paper,
        },
        "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator--sideRight":
          {
            display: "none",
          },
        "& .MuiDataGrid-cell--flex": {
          wordBreak: "break-word",
        },
      }}
      slotProps={{ filterPanel: { getColumnForNewFilter } }}
      {...props}
    />
  );
};
export default DataGridPro;
